export default __webpack_public_path__ + "static/media/package.8d5e5c3b.png";